import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { GenericFormSectionComponent } from '@content/ui/generic-form';

@Component({
  selector: 'wl-generic-form-container',
  templateUrl: './generic-form-container.component.html',
  standalone: true,
  imports: [ContentSectionComponent, GenericFormSectionComponent],
})
export class GenericFormContainerComponent {
  readonly rendering = input<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);
}
